import Vue from "vue"
import vueCustomElement from "vue-custom-element"
import VueApollo from "vue-apollo"
import {
  InMemoryCache,
  IntrospectionFragmentMatcher
} from "apollo-cache-inmemory"
import { ApolloClient } from "apollo-client"
import { createHttpLink } from "apollo-link-http"
import * as components from "@holidayguru/holidayguru-components"
import introspectionQueryResultData from "../apollo/fragmentTypes.json"
import { currentLocale } from "../src/plugins/i18n"

import HgAmadeusPackageTourSearchWidget from "../src/widgets/AmadeusPackageTourSearch.vue"
import HgAmadeusHotelTourSearchWidget from "../src/widgets/AmadeusHotelTourSearch.vue"
import HgShortTripSearchWidget from "../src/widgets/ShortTripSearch.vue"
import HgCruiseCompassSearchWidget from "../src/widgets/CruiseCompassSearch.vue"

Vue.config.productionTip = false

// Font Awesome
import "../src/plugins/font-awesome"

// i18n
import { i18n } from "../src/plugins/i18n"

const apolloProvider = getApollo("bild")
const apolloProviderUrlaub = getApollo("urlaub-bild")
const apolloProviderHotel = getApollo("hotel-bild")

// Styles
import "@holidayguru/holidayguru-components/dist/holidayguru-components.css"

HgAmadeusPackageTourSearchWidget.apolloProvider = apolloProviderUrlaub
HgAmadeusHotelTourSearchWidget.apolloProvider = apolloProviderHotel
HgShortTripSearchWidget.apolloProvider = apolloProvider
HgCruiseCompassSearchWidget.apolloProvider = apolloProvider

HgAmadeusPackageTourSearchWidget.i18n = i18n
HgAmadeusHotelTourSearchWidget.i18n = i18n
HgShortTripSearchWidget.i18n = i18n
HgCruiseCompassSearchWidget.i18n = i18n

Object.keys(components).forEach(componentName => {
  Vue.component(componentName, components[componentName])
})

// Use Plugins
Vue.use(vueCustomElement)
Vue.use(VueApollo)
Vue.apolloProvider = apolloProvider

// Define Element
Vue.customElement(
  "hg-amadeus-package-tour-search",
  HgAmadeusPackageTourSearchWidget
)
Vue.customElement(
  "hg-amadeus-hotel-tour-search",
  HgAmadeusHotelTourSearchWidget
)
Vue.customElement("hg-short-trip-search", HgShortTripSearchWidget)
Vue.customElement("hg-cruise-compass-search", HgCruiseCompassSearchWidget)

setTimeout(() => {
  if (document) {
    if (document.querySelector(".vue-portal-target")) {
      document.querySelector(".vue-portal-target").classList.add("holidayguru")
    }
    document.querySelector("html").style.fontSize = "16px"
  }
}, 300)

function getApollo(provider) {
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  })

  const httpLink = createHttpLink({
    uri: "https://graphql.holidayguru.de",
    headers: {
      "x-locale": currentLocale,
      "x-provider": provider
    }
  })

  // Cache
  const cache = new InMemoryCache({ fragmentMatcher })

  // Apollo Client
  const apolloClient = new ApolloClient({
    link: httpLink,
    cache
  })

  // Apollo Provider
  return new VueApollo({
    defaultClient: apolloClient
  })
}
